import { IDeviceTree } from "@types"
import { protectedApi } from "store/Api"

const deviceApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchDevice: builder.query<IDeviceTree[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devicetree`,
                }
            },
        }),
    }),
})

export const { useFetchDeviceQuery } = deviceApi
